/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface ContentCapabilitiesAPI
	 * @classdesc public API interface to retrieve content capabilities
	 */
	class ContentCapabilitiesAPI {
		/**
		 * @public
		 * @description Get Capabilities of a registered content type
		 * @returns {Object} [object = {
		 *	'selection': false,
	     *	'title': false,
		 *	'move': false,
		 *	'resize': false
		 *	}]
		 * returns capabilities of a registered content type.
		 */
		getCapabilities() {}
	}
	return ContentCapabilitiesAPI;
});